// ============================================================
// memoLog — 予約メモへのアクションログ追記（純粋関数）
//
// useMoveSwap から抽出（2026-07-03 Phase 3）。
// 「エントリの生成」と「追記」を分離しているのは、メモ永続化
// (saveScheduleChange) が **サーバー側の最新メモ** にエントリを
// 追記する必要があるため:
//   - 楽観更新: appendMemoLog(キャッシュ予約, ...) → 画面に即反映
//   - 永続化:   appendMemoEntry(freshのメモ, entry) → 既存メモを消さない
// キャッシュ予約は detail 未ロードで memo が空のことがあり、
// キャッシュ由来の memo をそのまま送るとサーバーの既存メモを
// 上書き消去する危険がある（580件事象と同根の partial update 問題）。
// ============================================================

import { Reservation } from './types';

/** 操作者名を解決（window.bo_staff → localStorage → 'システム'） */
function resolveStaffName(): string {
  if (typeof window !== 'undefined') {
    if ((window as any).bo_staff?.name) {
      return (window as any).bo_staff.name;
    }
    try {
      const saved = localStorage.getItem('bo_staff');
      if (saved) return JSON.parse(saved).name || 'システム';
    } catch { /* ignore */ }
  }
  return 'システム';
}

/** アクションログ1件分のエントリ文字列を生成（操作者名 + タイムスタンプ付き） */
export function buildMemoEntry(action: string, detail: string): string {
  const now = new Date();
  const ts = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  const header = `---${action} ${resolveStaffName()} ${ts}---`;
  return detail ? `${header}\n${detail}\n---` : `${header}\n---`;
}

/** 既存メモにエントリを追記 */
export function appendMemoEntry(currentMemo: string | undefined | null, entry: string): string {
  return currentMemo ? `${currentMemo}\n${entry}` : entry;
}

/** 予約オブジェクトのメモにアクションログを追記（楽観更新用） */
export function appendMemoLog(reservation: Reservation, action: string, detail: string): Reservation {
  const entry = buildMemoEntry(action, detail);
  return { ...reservation, memo: appendMemoEntry(reservation.memo || '', entry) };
}
